let x, i, j, selElement, a, b, c
x = document.getElementsByClassName("custom-select")
for (i = 0; i < x.length; i++) {
    selElement = x[i].getElementsByTagName("select")[0]
    a = document.createElement("div")
    a.setAttribute("class", "select-selected")
    a.innerHTML = selElement.options[selElement.selectedIndex].innerHTML
    x[i].appendChild(a)
    b = document.createElement("div")
    b.setAttribute("class", "select-items select-hide")
    for (j = 0; j < selElement.length; j++) {
        c = document.createElement("div")
        c.innerHTML = selElement.options[j].innerHTML
        c.addEventListener("click", function(e) {
            let y, i, k, s, h, yl
            s = this.parentNode.parentNode.getElementsByTagName("select")[0]
            h = this.parentNode.previousSibling
            for (i = 0; i < s.length; i++) {
                if (s.options[i].innerHTML.trim() === this.innerHTML.trim()) {
                    s.selectedIndex = i
                    h.innerHTML = this.innerHTML
                    y = this.parentNode.getElementsByClassName("same-as-selected")
                    yl = y.length
                    for (k = 0; k < yl; k++) {
                        y[k].removeAttribute("class")
                    }
                    this.setAttribute("class", "same-as-selected")
                    break
                }
            }
            h.click()

            if (s.getAttribute('data-change-option') !== null) s.dispatchEvent(new Event("change"))
        })
        b.appendChild(c)
    }
    x[i].appendChild(b)
    a.addEventListener("click", function(e) {
        e.stopPropagation()
        closeAllSelect(this)
        this.nextSibling.classList.toggle("select-hide")
        this.classList.toggle("select-arrow-active")
    })
}

function closeAllSelect(element) {
    let x, y, i, arrNo = []
    x = document.getElementsByClassName("select-items")
    y = document.getElementsByClassName("select-selected")
    for (i = 0; i < y.length; i++) {
        if (element === y[i]) {
            arrNo.push(i)
        } else {
            y[i].classList.remove("select-arrow-active")
        }
    }
    for (i = 0; i < x.length; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide")
        }
    }
}

document.addEventListener("click", closeAllSelect)
